import { DollarCircleOutlined, EllipsisOutlined } from "@ant-design/icons";
import {
	TickIcon,
	EditOutlineIcon,
	DeleteOutlineIcon,
	DollarCircleIcon,
} from "../../../common/icons";
import { Button, Dropdown, Menu } from "antd";
import "./style.css";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { ProjectApprovalStatus } from "../../../../utils/constants";

const Project = ({ editHandler, index, project, deleteHandler, readOnly }) => {
	const [showOptional, setShowOptional] = useState(false);
	const { t } = useTranslation();
	const onClickSeeMoreDetail = useCallback(() => {
		setShowOptional(!showOptional);
	}, [showOptional]);

	const optionalJsx = (
		<div className="project_details_optional_container">
			<div className="project_details_optional_item_container">
				<div className="title">{t("createProject_address")}</div>
				<div className="description">{project.location}</div>
			</div>
			<div className="project_details_optional_item_container">
				<div className="title">{t("projectCard_description_header")}</div>
				<div className="description">{project.details}</div>
			</div>
			<div className="project_details_optional_item_container">
				<div className="title">{t("projectCard_softSkill_header")}</div>
				<div className="description">
					{project.softSkills && (
						<ul>
							{project.softSkills.split(",").map((skill) => (
								<li>{skill}</li>
							))}
						</ul>
					)}
				</div>
			</div>
			<div className="project_details_optional_item_container">
				<div className="title">{t("projectCard_devEnv_header")}</div>
				<div className="description">{project.developmentEnvironment}</div>
			</div>
			<div className="project_details_optional_item_container">
				<div className="title">{t("projectCard_stagingEnv_header")}</div>
				<div className="description">{project.stagingEnvironment}</div>
			</div>
			<div className="project_details_optional_item_container">
				<div className="title">{t("projectCard_operationalEnv_header")}</div>
				<div className="description">{project.operationalEnvironment}</div>
			</div>
			<div className="project_details_optional_item_container">
				<div className="title">{t("projectCard_otherComment_header")}</div>
				<div className="description">{project.otherComment}</div>
			</div>
		</div>
	);

	const menu = (
		<Menu>
			<Menu.Item key="edit" onClick={() => editHandler(project, index)}>
				<EditOutlineIcon width={20} height={20} />
				{t("projectCard_action_edit")}
			</Menu.Item>
			<Menu.Item key="delete" onClick={() => deleteHandler(project, index)}>
				<DeleteOutlineIcon width={20} height={20} />
				{t("projectCard_action_delete")}
			</Menu.Item>
		</Menu>
	);

	return (
		<>
			<div className="project_card_container">
				<div className="project_card_title_container">
					<div className="project_card_title_body_container">
						<div className="project_card_title_banner">
							<div className="project_card_title_banner_projectNumber">{`${t(
								"project"
							)} #${index}`}</div>
							<div className="project_card_title_banner_requiredIntern">{`${t(
								"projectCard_banner_requiredIntern"
							)} : ${project.requiredEngineerCount}`}</div>

							{project.status === ProjectApprovalStatus.approved ? (
								<div className="project_card_title_banner_approvalStatus_approved">
									<TickIcon width={10} height={10} />
									{t("projectStatus_approved")}
								</div>
							) : (
								<div className="project_card_title_banner_approvalStatus_pendingApproval">
									{t("projectStatus_pendingApproval")}
								</div>
							)}
						</div>
						<div className="project_card_title">{project.title}</div>
					</div>
					<div className="project_card_title_action_container">
						{!readOnly && (
							<Dropdown
								overlay={menu}
								trigger={["click"]}
								key="ellipsis"
								placement="bottomRight"
							>
								<EllipsisOutlined
									style={{ fontSize: "30px", cursor: "pointer" }}
								/>
							</Dropdown>
						)}
					</div>
				</div>
				<div className="project_card_salary_container">
					<DollarCircleIcon width={20} height={20} />{" "}
					<span>{t("projectCard_salary_header")} :</span>{" "}
					{` ${project.salaryFrom} ~ ${project.salaryTo}`} <span>JPY</span>
				</div>
				<div className="project_card_body_container">
					<div className="project_card_body_container_row">
						<div className="header">
							{t("projectCard_mustHaveSkill_header")}
						</div>
						<div className="body">
							{project.mustHaveSkills?.map((elm) => (
								<div>{elm}</div>
							))}
						</div>
					</div>
					<div className="project_card_body_container_row">
						<div className="header">
							{t("projectCard_anyOneOfSkill_header")}
						</div>
						<div className="body">
							{project.oneOfTheFollowingSkills?.map((elm) => (
								<div>{elm}</div>
							))}
						</div>
					</div>
					<div className="project_card_body_container_row">
						<div className="header">
							{t("projectCard_niceToHaveSkill_header")}
						</div>
						<div className="body">
							{project.niceToHaveSkills?.map((elm) => (
								<div>{elm}</div>
							))}
						</div>
					</div>
				</div>

				{showOptional && (
					<div className="project_card_body_container_row">{optionalJsx}</div>
				)}
				<div className="project_card_footer_container">
					<Button type="link" size="small" onClick={onClickSeeMoreDetail}>
						{showOptional
							? `${t("projectCard_footerAction_close")}`
							: `${t("projectCard_footerAction_showMore")}`}
					</Button>
				</div>
			</div>
		</>
	);
};

export default Project;
